import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  DigitalMenuCategoryApi,
  FindDigitalMenuCategoriesWithDigitalMenuIDOption,
} from 'api';

export const findDigitalMenuCategory = createAsyncThunk(
  'digitalMenuCategory/findDigitalMenuCategory',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuCategoryApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDigitalMenuCategoryWithDigitalMenuID = createAsyncThunk(
  'digitalMenuCategory/findDigitalMenuCategoryWithDigitalMenuID',
  async (
    {
      digitalMenuID,
      option,
    }: {
      digitalMenuID: string;
      option: FindDigitalMenuCategoriesWithDigitalMenuIDOption;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await DigitalMenuCategoryApi.findWithDigitalMenuID(
        digitalMenuID,
        option
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateDigitalMenuCategory = createAsyncThunk(
  'digitalMenuCategory/updateDigitalMenuCategory',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await DigitalMenuCategoryApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createMultiDigitalMenuCategory = createAsyncThunk(
  'digitalMenuCategory/createMultiDigitalMenuCategory',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuCategoryApi.createMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createDigitalMenuCategory = createAsyncThunk(
  'digitalMenuCategory/createDigitalMenuCategory',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuCategoryApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeDigitalMenuCategory = createAsyncThunk(
  'digitalMenu/removeDigitalMenuCategory',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuCategoryApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateDigitalMenuCategoryOrder = createAsyncThunk(
  'digitalMenu/updateDigitalMenuCategoryOrder',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await DigitalMenuCategoryApi.updateOrder(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  reloadFlag: boolean;
  tableList: Array<any>;
  myList: Array<any>;
  purchaseList: Array<any>;
  purchaseReloadedRow?: any;
  collaboratorList: Array<any>;
  list: Array<any>;
  isLoadingTable: boolean;
}

const initialState: IState = {
  reloadFlag: false,
  tableList: [],
  myList: [],
  purchaseList: [],
  purchaseReloadedRow: undefined,
  collaboratorList: [],
  list: [],
  isLoadingTable: true,
};

const digitalMenuCategorySlice = createSlice({
  name: 'digitalMenuCategory',
  initialState,
  reducers: {
    reloadDigitalMenuCategory(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
});

const { actions, reducer: digitalMenuCategoryReducer } =
  digitalMenuCategorySlice;

export const { reloadDigitalMenuCategory } = actions;

export default digitalMenuCategoryReducer;
